import {
  Box,
  Button,
  Heading,
  MessageModalLayout,
  ModalMobileLayout,
  Text,
  WixDesignSystemProvider,
} from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import { PLUGIN_SETTINGS_PANEL_DISCARD_MODAL } from './../settings-panel-discard-modal/consts';

import classes from './settings-panel-discard-modal-scss';

export type DiscardPayload = { confirmed: boolean };

type SettingsPanelDiscardModalProps = {
  closeModal: (payload: DiscardPayload) => void;
};

export const SettingsPanelDiscardModal: React.FC<SettingsPanelDiscardModalProps> = ({
  closeModal,
}) => {
  const { t, isMobile } = useContext(RicosContext);

  const onCloseButtonClick = () => closeModal({ confirmed: false });

  const onPrimaryButtonClick = () => closeModal({ confirmed: true });

  const MobileLayout = () => (
    <ModalMobileLayout
      dataHook={PLUGIN_SETTINGS_PANEL_DISCARD_MODAL}
      onCloseButtonClick={onCloseButtonClick}
      title={<Heading size="medium">{t('PluginSettingsPanel_DiscardModal_Title')}</Heading>}
      content={<Text size="medium">{t('PluginSettingsPanel_DiscardModal_Content')}</Text>}
      footer={
        <Box align="right">
          <Box marginRight="12px">
            <Button priority="secondary" size="small" onClick={onCloseButtonClick}>
              {t('PluginSettingsPanel_DiscardModal_SecondaryButton_Text')}
            </Button>
          </Box>
          <Button size="small" onClick={onPrimaryButtonClick}>
            {t('PluginSettingsPanel_DiscardModal_PrimaryButton_Text')}
          </Button>
        </Box>
      }
    />
  );

  const DesktopLayout = () => (
    <MessageModalLayout
      dataHook={PLUGIN_SETTINGS_PANEL_DISCARD_MODAL}
      onCloseButtonClick={onCloseButtonClick}
      primaryButtonOnClick={onPrimaryButtonClick}
      secondaryButtonOnClick={onCloseButtonClick}
      primaryButtonText={t('PluginSettingsPanel_DiscardModal_PrimaryButton_Text')}
      secondaryButtonText={t('PluginSettingsPanel_DiscardModal_SecondaryButton_Text')}
      title={t('PluginSettingsPanel_DiscardModal_Title')}
      content={<Text>{t('PluginSettingsPanel_DiscardModal_Content')}</Text>}
    />
  );

  return (
    <WixDesignSystemProvider
      features={{ newColorsBranding: true }}
      className={classes.modal_container}
    >
      {isMobile ? <MobileLayout /> : <DesktopLayout />}
    </WixDesignSystemProvider>
  );
};
